import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, DownCircleOutlined, EditOutlined, DeploymentUnitOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={(row.nama ? row.nama : "-") + (row.kategori ? " (" + row.kategori + ")" : "")}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              Tahun Ajaran: {row.tahun_ajaran ? row.tahun_ajaran : ""}<br />
                              Pendaftaran: {row.tgl_pendaftaran ? row.tgl_pendaftaran : ""}<br />
                              Seleksi Administrasi: {row.tgl_seleksi_administrasi ? row.tgl_seleksi_administrasi : "-"} <br />
                              Seleksi Wawancara: {row.tgl_seleksi_wawancara ? row.tgl_seleksi_wawancara : "-"} <br />
                              Seleksi Tulis: {row.tgl_seleksi_tulis ? row.tgl_seleksi_tulis : "-"} <br />
                              Pengumuman: {row.tgl_pengumuman ? row.tgl_pengumuman : "-"} <br />
                              Registrasi: {row.tgl_registrasi ? row.tgl_registrasi : ""}<br />
                              Status: {row.is_open === "1" ? <Tag color="blue" icon={<CheckCircleOutlined />}>Aktif</Tag> : <Tag color="red" icon={<CloseCircleOutlined />}>Tidak Aktif</Tag>}
                            </small>
                          </Col>
                        </Row>
                      </>}

                    />
                    <div>
                      {(!action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.update ? [{
    key: 1,
    icon: <DeploymentUnitOutlined />,
    label: "Mapping Berkas Persyaratan",
    onClick: this.props.modalMappingBerkasPersyaratan.bind(this, true, row)
  }] : [])]
}}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
